import { FileResult, usePrevious } from 'common';
import { FC, useEffect, useState } from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { CfDialog } from '../dialogs/Dialog/CfDialog';
import { CfDocumentViewer } from './CfDocumentViewer';

export interface DocumentViewerDialogProps {
  isOpen: boolean;
  onClose?: () => void;
  fileResult?: FileResult;
  isLoading?: boolean;
}

export const CfDocumentViewerDialog: FC<DocumentViewerDialogProps> = (props: DocumentViewerDialogProps) => {
  const { isOpen, onClose, fileResult, isLoading } = props;

  const { deviceType } = useBreakpoint();
  const [isParsing, setIsParsing] = useState(false);
  const [fileName, setFileName] = useState<string>();
  const [fileSrc, setFileSrc] = useState<string>();
  const [fileType, setFileType] = useState<string>();
  const [downloadBlob, setDownloadBlob] = useState<Blob | undefined>(undefined);

  const prevFileSrc = usePrevious(fileSrc);

  const handleClose = () => {
    setIsParsing(false);
    setFileName(undefined);
    setFileSrc(undefined);
    setFileType(undefined);
    setDownloadBlob(undefined);
    onClose?.();
  };
  const getPDf = async (): Promise<void> => {
    setIsParsing(true);

    if (fileResult && fileResult.FileData) {
      setFileName(fileResult.FileName);
      setFileType(fileResult.FileContentType);
      const byteString = window.atob(fileResult.FileData);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const blob = new Blob([int8Array], { type: fileResult.FileContentType });
      const fileURL = URL.createObjectURL(blob);
      setFileSrc(fileURL);
      setDownloadBlob(blob);
      setIsParsing(false);
    } else {
      setIsParsing(false);
    }
  };

  useEffect(() => {
    if (isOpen && !isLoading) getPDf();
  }, [isOpen, isLoading]);

  if (!props.isLoading) {
    return (
      <CfDialog
        dataTestId='document-viewer-dialog'
        closeButtonDataTestId='document-viewer-cancel-btn'
        isOpen={isOpen}
        onClose={handleClose}
        paperSx={{ height: '100%', width: '100%' }}
        contentContainerSx={{ height: '95%' }}
        dialogContainerSx={{ mb: 3 }}
      >
        {isOpen && fileSrc && fileType && fileName && downloadBlob && (
          <CfDocumentViewer fileName={fileName} fileSrc={fileSrc} fileType={fileType} downloadBlob={downloadBlob} />
        )}
      </CfDialog>
    );
  } else {
    return (
      <CfDialog
        dataTestId='document-viewer-dialog'
        closeButtonDataTestId='document-viewer-cancel-btn'
        isOpen={isOpen}
        isLoading={isParsing || isLoading}
        onClose={onClose}
        paperSx={{ height: '100%', width: '100%' }}
        contentContainerSx={{ height: '95%' }}
        dialogContainerSx={{ mb: 3 }}
      />
    );
  }
};
